var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconClicks01 = function SvgIconClicks01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_clicks-01_svg2__a",
    x1: 0,
    x2: 100,
    y1: 50,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M50 100a2.7 2.7 0 0 1-.49-.04 3.32 3.32 0 0 1-2.7-2.34l-20-66.66c-.35-1.17-.03-2.45.84-3.31.87-.87 2.15-1.19 3.31-.84l66.67 20c1.24.37 2.15 1.42 2.34 2.7s-.37 2.55-1.45 3.27L81.9 63.86l17.12 17.13c1.3 1.3 1.3 3.41 0 4.71L85.69 99.03c-1.3 1.3-3.41 1.3-4.71 0L63.85 81.91 52.77 98.53c-.62.94-1.67 1.49-2.77 1.49Zm13.33-26.67c.88 0 1.73.35 2.36.98l17.64 17.64 8.62-8.62-17.64-17.64a3.333 3.333 0 0 1 .51-5.13l14.1-9.4-53.95-16.18 16.18 53.95 9.4-14.1c.55-.83 1.45-1.37 2.44-1.47.11-.01.22-.01.33-.01ZM19.02 19.02c1.3-1.3 1.3-3.41 0-4.71l-6.67-6.67a3.332 3.332 0 0 0-4.71 4.71l6.67 6.67c.65.65 1.5.98 2.36.98s1.71-.33 2.36-.98ZM16.67 30c0-1.84-1.49-3.33-3.33-3.33H3.33C1.49 26.67 0 28.16 0 30s1.49 3.33 3.33 3.33h10c1.84 0 3.33-1.49 3.33-3.33Zm-4.31 22.36 6.67-6.67a3.332 3.332 0 0 0-4.71-4.71l-6.67 6.67c-1.3 1.3-1.3 3.41 0 4.71.65.65 1.5.98 2.36.98s1.71-.33 2.36-.98Zm33.33-33.34 6.67-6.67a3.332 3.332 0 0 0-4.71-4.71l-6.67 6.67c-1.3 1.3-1.3 3.41 0 4.71.65.65 1.5.98 2.36.98s1.71-.33 2.36-.98Zm-12.36-5.69v-10C33.33 1.49 31.84 0 30 0s-3.33 1.49-3.33 3.33v10c0 1.84 1.49 3.33 3.33 3.33s3.33-1.49 3.33-3.33",
    style: {
      fill: "url(#icon_clicks-01_svg2__a)"
    }
  }));
};
export default SvgIconClicks01;